import { loadStripe } from "@stripe/stripe-js";

let stripePromise = null;

/**
 * Returns a shared Stripe.js instance using the publishable key.
 * Secret keys must never be used in the frontend.
 */
export function getStripe() {
  const publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

  if (!publishableKey) {
    return Promise.resolve(null);
  }

  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }

  return stripePromise;
}

export function getStripePublishableKey() {
  return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || "";
}

export function hasStripePublishableKey() {
  return Boolean(getStripePublishableKey());
}

/**
 * Convert a dollar amount to Stripe's smallest currency unit (cents).
 * @param {number} amount
 * @returns {number}
 */
export function toStripeAmount(amount) {
  return Math.max(0, Math.round(Number(amount || 0) * 100));
}
